@import "node_modules/@glidejs/glide/src/assets/sass/glide.core";

app-hero-slider {
    position: relative;
    display: block;
}
    .app-hero-slider.hero-layout.large {
    
        .hero-content {

            & > div {
                z-index: 2;
                display: flex;
                flex-direction: row-reverse;
                align-items: center;
                height: 100%;
                min-width: 400px;
                justify-content: flex-end;
            }

            .hero-content-block {
                z-index: 2;
                max-width: 520px;
                padding-bottom: 30px;
            }
            .hero-pre-heading {
                text-transform: lowercase;
                @include text-size(31.2);
                @include line-height(41);
                color: #618db4;
                font-weight: 300;
                font-family: $font-family-secondary;
            }
            .hero-ctas {
                margin-top: 20px;
                display: flex;
    
                .btn {
                    margin: 5px 10px 5px 0;
    
                    &.btn-white {
                        border-color: $primary;
                    }
                }
            }
        }
    
    
        .st-carousel {
            position: relative;
    
            &.hide-controls {
                .slider-arrow, .bullets-wrapper { display: none !important; }
            }
            .st-carousel-inner {
                position: relative;
                z-index: 2;
                background-color: $gray-lite;
            }
    
            .glide__slides {
                white-space: normal;
                height: 100%;

                app-hero-slide {
                    z-index: -5;

                    .app-hero-slide {
                        z-index: -5;
                    }
                }
            }
    
            .slider-arrow {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                @include transitionDefault(all);
                
                button {
                    border: none;
                    background: transparent;
                    padding: 0 20px;

                    &:focus {
                        outline: 1px solid #000;
                    }
                }
                
    
                &.arrow-prev {
                    left: 0;
    
                    svg {
                        fill: $gray-medium;
                        transform: rotate(180deg);
                        width: 26px;
                        height: 26px;
                        z-index: 3;
    
                    }
    
                    &:hover {
                        left: -7px;
                        filter: brightness(0.8);

                    }
                }
    
                &.arrow-next {
                    right: 0;
                    margin-right: 15px;
    
                    svg {
                        fill: $gray-medium;
                        width: 26px;
                        height: 26px;
                        z-index: 3;
                    }
    
                    &:hover {
                        right: -7px;
                        filter: brightness(0.8);

                    }
                }
            }
    
            .bullets-wrapper {
                display: flex;
                align-items: center;
                position: absolute;
                bottom: 10px;
                left: calc(50% - 55px);
                
    
                .glide__bullets {
                    display: flex;
                    height: 17px;
                    align-items: center;
                    z-index: 2;
                }
    
                .glide__bullet {
                    height: 12px;
                    width: 12px;
                    background: transparent;
                    border-radius: 100%;
                    border: 1px solid $gray-medium;
                    margin: 0 5px;
                    padding: 2px;
                    @include transitionDefault(all);
    
                    &:hover {
                        border-color: $secondary;
                    }
    
                    &.glide__bullet--active {
                        background-color: $gray-medium;
    
                        &:hover {
                            background-color: $secondary;
                            border-color: $secondary;
                        }
                    }
                }
            }
            .hero-slider-pause {
                position: absolute;
                bottom: 16px;
                right: 20px;
                border: none;
                background: transparent;
                height: 44px;
                width: 44px;

                &:before {
                    content: '';
                    display: block;
                    background: #fff;
                    height: 100%;
                    width: 100%;
                    border-radius: 100%;
                    border: 1px solid #fff;
                    padding: 2px;
                    position: absolute;
                    top: -3px;
                    left: 0;
                    opacity: 0;
                    @include transitionDefault(all);
                }

                svg {
                    @include svg-format(25px, 25px, $united-gray);
                    position: absolute;
                    top: 45%;
                    left: 45%;
                    transform: translate(-50%, -50%);
                    @include transitionDefault(all);
                    padding-left: 0;
                }

                &:is(:hover, :focus-within), &.paused {
                    &:before {
                        opacity: 1;
                        background-color: $secondary;
                        top: -4px;
                        left: -3px;
                    }
    
                    svg {
                        @include svg-format(20px, 20px, #FFFFFF);
                    }
                }
            }
        }  
    }
@media only screen and (max-width: 1000px) {
    .app-hero-slider {
        &.hero-layout.large {
            .st-carousel {

                .st-carousel-inner {
                    background-color: transparent;
                }
                .slider-arrow {
                    top: 15%;
                    max-height: fit-content;
                }

                .hero-slider-pause {
                    bottom: auto;
                    top: 300px;
                    width: 30px;
                    height: 30px;

                    &::before {
                        width: 40px;
                        height: 40px;
                    }

                    &.paused {
                        svg {
                            @include svg-format(20px, 20px, $primary);
                            padding-top: 5px;
                            padding-left: 5px;
                        }
                    }
                    &:is(:hover, :focus-within) {
                        svg {
                            padding-top: 5px;
                            padding-left: 5px; 

                        }
                    }
                }
            }
            .hero-content {
                flex-direction: column;

                > div {
                    display: block;
                    min-width: unset;
                    max-width: 100%;
                }

                .hero-pre-heading {
                    @include text-size(21);
                    @include line-height(27);
                }
                
                .hero-content-block {
                    max-width: 100%;
                }
                .hero-ctas {
                    flex-direction: column;
                    align-items: center;
                }
            }
        }
    }
}
@media only screen and (max-width: 500px) {
    .app-hero-slider.hero-layout.large {
        .st-carousel {
            .hero-slider-pause {
                top: 175px;
            }
        }
    }
}

// Hide slider arrows in SF page editor
.is-editing {
    .slider-arrow {
        display: none !important;
    }
}